import { defineComponent } from 'vue';
import { useService } from '@kaokei/use-vue-service';
import { CheatService } from '@/services/exam/cheat.service';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
export default defineComponent({
  name: 'CheatMask',
  components: {
    ExclamationCircleFilled: ExclamationCircleFilled
  },
  setup: function setup() {
    var cheatService = useService(CheatService);
    cheatService.initEvent();
    return {
      cheatService: cheatService
    };
  }
});